import useAppQuery from 'hooks/useAppQuery';
import API from 'services/API';

const useSignAudienceScopedToken = ({
  agencyUid,
  audience,
  enabled,
}: {
  agencyUid: string;
  audience: string;
  enabled: boolean;
}) => {
  return useAppQuery<{
    accessToken: string;
    expiresIn: number;
    tokenType: 'Bearer'; // add other types when supported
  }>({
    queryKey: ['audienceScopedToken', agencyUid, audience],
    queryFn: async () => {
      const response = await API.post(
        `/api/identity/token/sign?audience=${audience}`,
      );

      return response.data;
    },
    enabled: enabled && !!agencyUid && !!audience,
  });
};

export default useSignAudienceScopedToken;
